/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/prefer-default-export */
/* eslint-disable react/require-default-props */
import React from "react";
import { Row } from "../Layout";
import styles from "./modal.module.css";

type dialogProps = {
  title?: string;
  isOpen?: boolean;
  content: JSX.Element;
};

export const Modal = (props: dialogProps) => {
  const { isOpen, content, title } = props;
  // todo make use of useComponentVisible hook for detecting click
  return (
    <>
      {isOpen && (
        <div className="dialog">
          <div className="dialog-content">
            {title && (
              <div className={styles.ModalTitle}>
                <p className="dialog-title px-4">{title}</p>
              </div>
            )}
            <div className={styles.ModalContent}>
              <Row>{content}</Row>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Modal.defaultProps = {
  isOpen: false,
};
